import { ChainProtocol, Token } from '@archax/shared-types'

/**
 * Extracts the contract address/id to be used from the token deployment result.
 * To be used to check the balance of the token.
 */
export const extractTokenHolderAddress = (token: Token) => {
  const {
    standard: {
      chain: { protocol },
    },
  } = token

  switch (protocol) {
    case ChainProtocol.Arbitrum:
    case ChainProtocol.Ethereum:
    case ChainProtocol.Etherlink:
    case ChainProtocol.Polygon:
    case ChainProtocol.XDC:
      return token.deploymentResult.contract.address
    case ChainProtocol.Hedera:
      return token.deploymentResult.contractId
    case ChainProtocol.Stellar:
      if (token.deploymentResult.nativeAccountAddress) {
        return token.deploymentResult.nativeAccountAddress
      }
      return token.deploymentResult.tokenId
    case ChainProtocol.Solana:
      throw new Error('Under development')
    default:
      throw new Error(`${protocol} protocol not supported`)
  }
}
